import React, { useEffect, useState, useTransition } from 'react'
import cl from './CollectingScores.module.css'
import { Button, Checkbox, Divider, Flex, Grid, Heading, Input, Menu, MenuButton, MenuItem, MenuList, Select, Text } from '@chakra-ui/react'
import { useScoreStore } from '../../store/scoreStore'

function CollectingScoresFilters() {
    const filters = useScoreStore(state => state.filters)
    const setFilters = useScoreStore(state => state.setFilters)
    const tags = useScoreStore(state => state.tags)
    const updateFilteredData = useScoreStore(state => state.updateFilteredData)
    const isFiltering = useScoreStore(state => state.isFiltering)
    const setIsFiltering = useScoreStore(state => state.setIsFiltering)
    const [, startTransition] = useTransition()
    const [query, setQuery] = useState(filters?.query || '')
    const [selectedCohorts, setSelectedCohorts] = useState(filters.cohorts)
    const [selectedSources, setSelectedSources] = useState(filters.sources)

    useEffect(() => {
        setIsFiltering(true)
        startTransition(() => {
            setTimeout(() => {
                updateFilteredData()
                setIsFiltering(false)
            }, 0)
        })
    }, [filters])

    const handleSourceChange = (source) => {
        const exists = selectedSources.includes(source)
        if (exists)
            setSelectedSources(selectedSources.filter(s => s !== source))
        else
            setSelectedSources([...selectedSources, source])
    }

    const handleCohortChange = (cohort) => {
        const exists = selectedCohorts.includes(cohort)
        if (exists)
            setSelectedCohorts(selectedCohorts.filter(c => c !== cohort))
        else
            setSelectedCohorts([...selectedCohorts, cohort])
    }

    return (
        <Grid className={cl.container} marginRight='auto'>
            <Heading size='md'>Фильтрация и поиск</Heading>
            <Flex gap='var(--default-gap)'>
                <Select
                    size='sm'
                    disabled={isFiltering}
                    placeholder='Класс'
                    value={filters.classYearId}
                    onChange={e => setFilters({...filters, classYearId: Number(e.target.value)})}
                >
                    <option value={1}>9 класс</option>
                    <option value={3}>11 класс</option>
                </Select>
                <Select
                    size='sm'
                    disabled={isFiltering}
                    placeholder='Предмет'
                    value={filters.subject}
                    onChange={e => setFilters({...filters, subject: e.target.value})}
                >
                    {filters.all_subjects.map(subject => (
                        <option value={subject} key={subject}>{subject}</option>
                    ))}
                </Select>
                <Select
                    size='sm'
                    disabled={isFiltering}
                    placeholder='Тег'
                    value={filters.tagId}
                    onChange={e => setFilters({...filters, tagId: Number(e.target.value)})}
                >
                    {tags.map(tag => (
                        <option value={tag.id} key={tag.id}>{tag.title}</option>
                    ))}
                </Select>
                <Menu closeOnSelect={false} onClose={() => setSelectedSources(filters.sources)}>
                    <MenuButton size='sm' minW='100px' as={Button} disabled={isFiltering}>
                        Источники
                    </MenuButton>
                    <MenuList zIndex="modal">
                        {filters.all_sources.map((source, i) => (
                            <MenuItem
                                key={`${i+1}-${source}`}
                                onClick={() => handleSourceChange(source)}
                            >
                                <Checkbox
                                    size='sm'
                                    disabled={isFiltering}
                                    colorScheme='orange'
                                    isChecked={selectedSources.includes(source)}
                                    pointerEvents='none'
                                >
                                    {source}
                                </Checkbox>
                            </MenuItem>
                        ))}
                        <Button
                            size='xs'
                            m='6px 12px'
                            onClick={() => setFilters({...filters, sources: [...selectedSources]})}
                        >
                            Применить
                        </Button>
                    </MenuList>
                </Menu>
                <Menu closeOnSelect={false} onClose={() => setSelectedCohorts(filters.cohorts)}>
                    <MenuButton size='sm' minW='100px' as={Button} disabled={isFiltering}>
                        Когорты
                    </MenuButton>
                    <MenuList zIndex="modal">
                        {filters.all_cohorts.map((cohort, i) => (
                            <MenuItem
                                key={`${i+1}-${cohort}`}
                                onClick={() => handleCohortChange(cohort)}
                            >
                                <Checkbox
                                    size='sm'
                                    disabled={isFiltering}
                                    colorScheme='orange'
                                    isChecked={selectedCohorts.includes(cohort)}
                                    pointerEvents='none'
                                >
                                    {cohort}
                                </Checkbox>
                            </MenuItem>
                        ))}
                        <Button
                            size='xs'
                            m='6px 12px'
                            onClick={() => setFilters({...filters, cohorts: [...selectedCohorts]})}
                        >
                            Применить
                        </Button>
                    </MenuList>
                </Menu>
                <Checkbox
                    disabled={isFiltering}
                    colorScheme='orange'
                    whiteSpace='nowrap'
                    isChecked={filters.wrongFormat}
                    onChange={e => setFilters({...filters, wrongFormat: e.target.checked})}
                >
                    <Text fontSize='sm'>Неверный формат</Text>
                </Checkbox>
            </Flex>
            <Divider />
            <Flex gap='var(--default-gap)'>
                <Input
                    size='sm'
                    disabled={isFiltering}
                    placeholder='Поиск по имени / почте / id на платформе / номер тел'
                    value={query}
                    onChange={e => setQuery(e.target.value.toLowerCase())}
                />
                <Button
                    size='sm'
                    minW='150px'
                    disabled={isFiltering || query === filters?.query}
                    onClick={() => setFilters({...filters, query: query})}
                >
                    Поиск
                </Button>
            </Flex>
        </Grid>
    )
}

export default CollectingScoresFilters
